import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Mail } from "lucide-react";

export default function NewsletterForm({ source = "footer", variant = "block" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setDone(true);
      toast.success(data.already_subscribed ? "Zaten kayıtlısın 🌿" : "Kayıt olundun 🌿");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Kayıt başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={
        variant === "inline"
          ? "flex flex-col gap-3"
          : "rounded-[2rem_1rem_2rem_1rem] border border-earth-400/30 bg-earth-400/10 p-8 md:p-10"
      }
      data-testid={`newsletter-${source}`}
    >
      {variant !== "inline" && (
        <>
          <div className="flex items-center gap-2 text-sage-700">
            <Mail className="h-5 w-5" />
            <span className="font-body text-sm font-bold uppercase tracking-widest">Bülten</span>
          </div>
          <h3 className="mt-3 font-display text-4xl text-ink-900" data-testid="newsletter-title">
            Yeni yazılardan haberdar ol
          </h3>
          <p className="mt-2 font-body text-ink-700">
            Ayda bir, okumaya değer birkaç şey ve yaklaşan atölye duyuruları. Spam yok, satış yok.
          </p>
        </>
      )}

      {done ? (
        <p className="mt-6 rounded-xl bg-sage-500/15 px-4 py-3 font-body text-sage-700" data-testid="newsletter-success">
          Teşekkürler — yakında görüşürüz 🌿
        </p>
      ) : (
        <form onSubmit={submit} className={variant === "inline" ? "flex gap-2" : "mt-6 flex flex-col gap-3 sm:flex-row"}>
          <input
            type="email"
            required
            placeholder="ornek@e-posta.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="k-input flex-1"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={busy}
            className="k-btn-primary disabled:opacity-60"
            data-testid="newsletter-submit"
          >
            {busy ? "Kaydediliyor…" : "Katıl"}
          </button>
        </form>
      )}
    </div>
  );
}
